export default "__VITE_ASSET__DOE11aXg__"